// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/icomoon.eot?a77w7v", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/icomoon.ttf?a77w7v", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/icomoon.woff?a77w7v", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/icomoon.svg?a77w7v", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#icomoon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "icomoon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-Delete:before {
  content: "\\e914";
}

.icon-link:before {
  content: "\\e9cb";
}

.icon-page-right:before {
  content: "\\e912";
}

.icon-page-left:before {
  content: "\\e913";
}

.icon-plus:before {
  content: "\\e910";
  color: #797575;
}

.icon-close:before {
  content: "\\e911";
  color: #4d4d4d;
}

.icon-tick-transparent:before {
  content: "\\e90e";
  color: #fff;
}

.icon-down:before {
  content: "\\e90d";
  color: #948a8a;
}

.icon-edit:before {
  content: "\\e90a";
}

.icon-eye:before {
  content: "\\e90b";
}

.icon-question-menu:before {
  content: "\\e90f";
  color: #189c5c;
}

.icon-arrow-left:before {
  content: "\\e90c";
}

.icon-bell:before {
  content: "\\e908";
}

.icon-search:before {
  content: "\\e909";
}

.icon-thumbs-up:before {
  content: "\\e900";
  color: #fff;
}

.icon-message:before {
  content: "\\e901";
  color: #fff;
}

.icon-mail:before {
  content: "\\e902";
  color: #fff;
}

.icon-layout:before {
  content: "\\e903";
  color: #fff;
}

.icon-user-check:before {
  content: "\\e904";
  color: #fff;
}

.icon-users:before {
  content: "\\e905";
  color: #fff;
}

.icon-book-open:before {
  content: "\\e906";
  color: #fff;
}

.icon-menu:before {
  content: "\\e907";
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/icons/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,4CAAA;EACA,mPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAFF;AAKA;EACE,+EAAA;EACA,iCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAMA;EACE,gBAAA;AAHF;;AAKA;EACE,gBAAA;AAFF;;AAIA;EACE,gBAAA;AADF;;AAGA;EACE,gBAAA;EACA,cAAA;AAAF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AACA;EACE,gBAAA;EACA,WAAA;AAEF;;AAAA;EACE,gBAAA;EACA,cAAA;AAGF;;AADA;EACE,gBAAA;AAIF;;AAFA;EACE,gBAAA;AAKF;;AAHA;EACE,gBAAA;EACA,cAAA;AAMF;;AAJA;EACE,gBAAA;AAOF;;AALA;EACE,gBAAA;AAQF;;AANA;EACE,gBAAA;AASF;;AAPA;EACE,gBAAA;EACA,WAAA;AAUF;;AARA;EACE,gBAAA;EACA,WAAA;AAWF;;AATA;EACE,gBAAA;EACA,WAAA;AAYF;;AAVA;EACE,gBAAA;EACA,WAAA;AAaF;;AAXA;EACE,gBAAA;EACA,WAAA;AAcF;;AAZA;EACE,gBAAA;EACA,WAAA;AAeF;;AAbA;EACE,gBAAA;EACA,WAAA;AAgBF;;AAdA;EACE,gBAAA;EACA,WAAA;AAiBF","sourcesContent":["@font-face {\n  font-family: 'icomoon';\n  src:  url('fonts/icomoon.eot?a77w7v');\n  src:  url('fonts/icomoon.eot?a77w7v#iefix') format('embedded-opentype'),\n    url('fonts/icomoon.ttf?a77w7v') format('truetype'),\n    url('fonts/icomoon.woff?a77w7v') format('woff'),\n    url('fonts/icomoon.svg?a77w7v#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-\"], [class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-Delete:before {\n  content: \"\\e914\";\n}\n.icon-link:before {\n  content: \"\\e9cb\";\n}\n.icon-page-right:before {\n  content: \"\\e912\";\n}\n.icon-page-left:before {\n  content: \"\\e913\";\n}\n.icon-plus:before {\n  content: \"\\e910\";\n  color: #797575;\n}\n.icon-close:before {\n  content: \"\\e911\";\n  color: #4d4d4d;\n}\n.icon-tick-transparent:before {\n  content: \"\\e90e\";\n  color: #fff;\n}\n.icon-down:before {\n  content: \"\\e90d\";\n  color: #948a8a;\n}\n.icon-edit:before {\n  content: \"\\e90a\";\n}\n.icon-eye:before {\n  content: \"\\e90b\";\n}\n.icon-question-menu:before {\n  content: \"\\e90f\";\n  color: #189c5c;\n}\n.icon-arrow-left:before {\n  content: \"\\e90c\";\n}\n.icon-bell:before {\n  content: \"\\e908\";\n}\n.icon-search:before {\n  content: \"\\e909\";\n}\n.icon-thumbs-up:before {\n  content: \"\\e900\";\n  color: #fff;\n}\n.icon-message:before {\n  content: \"\\e901\";\n  color: #fff;\n}\n.icon-mail:before {\n  content: \"\\e902\";\n  color: #fff;\n}\n.icon-layout:before {\n  content: \"\\e903\";\n  color: #fff;\n}\n.icon-user-check:before {\n  content: \"\\e904\";\n  color: #fff;\n}\n.icon-users:before {\n  content: \"\\e905\";\n  color: #fff;\n}\n.icon-book-open:before {\n  content: \"\\e906\";\n  color: #fff;\n}\n.icon-menu:before {\n  content: \"\\e907\";\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
